import { AvailabilityType } from '@/services/availability/useAvailabilityTypes';

export const getTeamCalendarLeaveTypeTextClass = (leaveType?: Pick<AvailabilityType, 'textColor'>) => {
  return leaveType?.textColor === 'Black' ? 'text-black' : 'text-white';
};
